module.exports = __webpack_public_path__ + "assets/img/tx102z.5da6c06d.jpg";